import './index.css'
import { notification, ConfigProvider } from 'antd'
import './App.css'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ptBR as ptBR_mui } from '@mui/material/locale';
import { default as ptBR_antd } from 'antd/es/locale/pt_BR'
import { GeneralContextProvider } from './context/GeneralContext/GeneralContextProvider'
import { Router } from './routes/Router'
import { colors } from './services/styles'

const theme = createTheme({ palette: { primary: { main: colors['primary'][600] } } }, ptBR_mui)

window.alert = (message, type = 'info', title = 'Atenção!', duration = 5, key = 'unique') => {
    notification[type]({
        key,
        message: title,
        description: message,
        placement: 'topRight',
        duration,
    })
}

function App() {
    return (
        <ConfigProvider
            locale={ptBR_antd}
            theme={{
                token: {
                    colorPrimary: colors.primary[600],
                    borderRadius: 4,
                    colorTextDisabled: colors.primary[900],
                },
            }}
        >
            <ThemeProvider theme={theme}>
                <GeneralContextProvider>
                    <Router />
                </GeneralContextProvider>
            </ThemeProvider>
        </ConfigProvider>
    )
}

export default App
